/*!
 *
 * 判断是否进入支付页面
 *
 *
 *参数一： router 当前路由
 *参数二：  params 支付页面需要的参数
 *参数三：  navigator 
 *
 */
// import {
//   PixelRatio,
//   ActivityIndicatorIOS,
//   Platform
//   } from 'react-native';
// import Login from './login/Login';
// import Payment from "./product/Payment/Payment";
// import FixedInvestment from "./product/Payment/FixedInvestment";/**/
// import { isLoginAndRealName, getTempInfo, getToastConfPoint } from '../CommonVar';
import { getTempInfo,getStorage} from './common.js';
// import goLogin, {goCertify} from './goLogin';
import { getRiskType,getQuestionnaireNo } from './action/questionnairesAction';
import { choseBankIndex,choseCurrentIndex ,choseBankOrCurrent,changeCurrentType,changeCurrentIndex } from './action/productAction';
import { querySuperFundAccAgreement,superFundAccAgreementState } from './action/investmentAction';
import store from './ReduxStore.js';
// import Toast from 'react-native-root-toast';
import Util from './util';
// import CertificationMainView from './myAssets/CertificationMainView';
// import QuestionnaireList from './myAssets/questionnaires/QuestionnaireList';
// import DeclareQualifiedInvestor from './myAssets/questionnaires/DeclareQualifiedInvestor';
// import HighestRiskPoint from './product/Payment/HighestRiskPoint';
import { Toast } from 'antd-mobile/lib';
import { setRiskModalData, setPayLoading } from './action/riskInPayAction';
import { 
  myPaymentText,
  myFee ,
  mySyncBtn,
  myPhoneNum,
  myVerifyCode
} from './action/publicAction';
import { 
  clearSmrzOne
} from './action/investmentAction';

import { hashHistory } from 'react-router';
const oldFetch = fetch;
let _fetch = (function(oldFetch){
  return function(url,options){
    var abort = null;
    var abort_promise = new Promise((resolve, reject)=>{
      abort = () => {
        console.info('abort done.');
        reject('abort');
        
      };
    });
    var promise = Promise.race([
      fetch(url,options),
      abort_promise
    ]);
    promise.abort = abort;
    return promise;
  };
})(fetch);

export let newFetch ;

export const goLogin = async ( callback ,route=false, params) => {
  let loginState=await getStorage('loginState');
  if (loginState=='0'||loginState==9999) {
    Toast.hide()
    //登录
    hashHistory.push({
        pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? '/LoginHxjj' : '/Login',
        state: {callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? callback : null,route:route, params: params}
    })
  }else if(loginState=='3'){
    //同步开户
    store.dispatch(mySyncBtn(3))
    store.dispatch(myPhoneNum(''))
    store.dispatch(myVerifyCode(''))
    hashHistory.push({
        pathname:'/BindingMobile',
        state: {callback:callback,route:route}
    })
  }else{
    callback()
  }
}
export const goHXJJLogin = async ( callback ,route=false) => {
  let loginState=await getStorage('loginState');
  if (loginState=='0'||loginState==9999) {
    //登录
    hashHistory.push({
        pathname: '/LoginHxjj',
        query:{
            enterType:'SubscriptionDetail',
        },
        state: {callback: callback,route:route}
    })
  }else if(loginState=='3'){
    //同步开户
    store.dispatch(mySyncBtn(3))
    store.dispatch(myPhoneNum(''))
    store.dispatch(myVerifyCode(''))
    hashHistory.push({
        pathname:'/BindingMobile',
        state: {callback:callback,route:route}
    })
  }else{
    callback()
  }
}
export const getLoginState = async ()=>{
  return await getStorage('loginState');
}
export const getPayAll = async (route, params, nav, component = null)=>{
  store.dispatch(myPaymentText(''))
  store.dispatch(myFee('--'))
  store.dispatch(choseBankIndex(0))
  store.dispatch(choseCurrentIndex(0))
  store.dispatch(choseBankOrCurrent(false))
  store.dispatch(changeCurrentType(4))
  store.dispatch(changeCurrentIndex(0))
  Toast.loading('', 0);
  if (component=='RechargeHqt') {
    store.dispatch({
      type:"HQT_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }else if(component=='PaymentSuperFund'){
    store.dispatch({
      type:"SUPER_FUND_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }else if(component=='FixedInvestmentSuperFund'){
    store.dispatch({
      type:"SUPER_FUND_DT_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }
  //已登录 已实名认证
  let flagDigital=await getStorage('loginState');
  let _currentUserInfo = await getStorage('currentUserInfo');
  if(flagDigital == '1'){
    //实名认证
    store.dispatch(clearSmrzOne())
    Toast.hide()
    nav.push({
        pathname:'/CertificationUpload',
        state:{
          route:route,
          phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
          callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? ()=>{getPayAll(route, params, nav, component)} : null
        }
    })
    return;
  }else if(flagDigital=='3'){

    Toast.hide()
    //同步开户
    nav.push({
        pathname:'/BindingMobile',
        state:{route:route,callback:()=>{getPayAll(route, params, nav, component)}}
    })
    return;
  }else if(flagDigital=='0'){
    Toast.hide()
    nav.push({
        pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? '/LoginHxjj' : '/Login',
        state:{route:route,callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? ()=>{getPayAll(route, params, nav, component)} : null}
    })
    return;
  }

  if(params && params.productType == "Z") {
    Toast.loading('', 0);
    let hasConvertFlag = null;
    try {
      hasConvertFlag = await hasConvertingTrade({superFundCode: params.fundCode}, () => {
        Toast.hide();
      }, () => {
        Toast.hide();
      });
    }catch(err) {
      Toast.hide();
      return;
    }
    if(hasConvertFlag === true) {
      Toast.show('当前智投组合有转换在途交易，该操作暂停', Util.ToastTime);
      return;
    }
    Toast.loading('', 0);
  }

  let didQuestionnairs = false;//后台接口 判断是否做了问卷
  try{
    didQuestionnairs = await judgeQuestionnaires(params.productType);
  }catch(err){
    // store.dispatch(setPayLoading(false));
    Toast.info(err.message, 2);
    return;
  }
  //如果是公募并且问卷没答完
  if((params.productType == 'S' ||params.productType == 'G' || params.productType == 'J' || params.productType == 'Z') && !didQuestionnairs){
    goPubQuestionnaires(nav, route, ()=>{getPayAll(route, params, nav, component)});
    return;
  }
  if(true){
    //调后台接口公募接口
    let riskCode = '';
    Toast.loading('', 0);
    try{
      riskCode = await getRiskFlag(params.fundCode, params.productType);
      console.log('+++++++++',riskCode);
    }catch(err){
      // store.dispatch(setPayLoading(false));
      if(err.message != 'abort'){
        // alert(err.message);
        Toast.info(err.message, 2);
      }
      return;
    }
    Toast.hide()
    if(riskCode.code == ''){
      // store.dispatch(setPayLoading(false));
      return;
    }else if(riskCode.code == '0000'){
      // store.dispatch(setPayLoading(false));
      if(component != null){
        nav.push({
          pathname: component,
          state:params,
          query:params,
        });
      }else{
        params.callback();
      }
      return;
    }else if(/^90\d\d$/.test(riskCode.code) && riskCode.userRiskLevel == "1"){
      store.dispatch(setPayLoading(true));
      let riskModalData = {
        title: '风险提示',
        content: '您当前的风险承受能力为最低风险等级，根据证监会发布的《关于实施<证券期货投资者适当性管理办法>的规定》，最低风险等级的客户不能购买产品风险等级高于自身风险承受能力的产品。如果您对自己的风险等级有异议，建议重新测评。',
        leftButtonTitle: '取消',
        rightButtonTitle: '重新测评',
        contentBC: params.fundName + '风险高于您的风险承受能力',
        onOK: ()=>{
          //跳到重新测评
          // goReCheck();
          params.fundRisk = true;
          // params.fundPart = false;
          // UmengStatis.onEvent('Pay_GoReCheck');
          goPubQuestionnaires(nav, route, ()=>{getPayAll(route, params, nav, component)});
          store.dispatch(setRiskModalData(null));
          store.dispatch(setPayLoading(false));
        },
        onCancel: ()=>{
          // UmengStatis.onEvent('Pay_ReCheckCancel');
          store.dispatch(setRiskModalData(null));
        }
      };
      store.dispatch(setRiskModalData(riskModalData));
      // store.dispatch(traceSave({action: 'TRADE_REFUSE', message: '安全型用户购买非货币基金：' + params.fundName}));
      return;
    }else if(/^02\d\d$/.test(riskCode.code) || /^\d\d0[2,8]$/.test(riskCode.code)){
      //特高产品提示页，做题
      // store.dispatch(setPayLoading(false));
      goHighestRiskPoint(nav, route, ()=>{
        params.fundRisk = true;
        if(component != null){
          nav.push({
            pathname: component,
            state:params,
            query:params
          });
        }else{
          params.callback();
        }
      }, params.fundName);
      return;
    }else if(/^06\d\d$/.test(riskCode.code)){
      store.dispatch(setPayLoading(true));
      let riskModalData = {
        title: '风险提示',
        content: '本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。',
        leftButtonTitle: '取消',
        rightButtonTitle: '继续购买',
        onOK: ()=>{
          store.dispatch(setRiskModalData(null));
          //购买
          params.fundRisk = true;
          if(component != null){
            nav.push({
              pathname:component,
              state:params,
              query:params,
            });
          }
        },
        onCancel: ()=>{
          store.dispatch(setRiskModalData(null));
        }
      };
      if(riskCode.code == '0606'){
        // riskModalData.contentBC = '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。';
        riskModalData.contentBC = '';
        riskModalData.onOK = ()=>{
          store.dispatch(setRiskModalData(null));
          //购买
          params.fundRisk = true;
          params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
          if(component != null){
            nav.push({
              pathname:component,
              state:params,
              query:params,
            });
          }
        }
      }
      store.dispatch(setRiskModalData(riskModalData));
      return;
    }else if(/^90\d\d$/.test(riskCode.code)){
      //限制购买
      // store.dispatch(setPayLoading(false));
      Toast.info('限制购买', 2);
      return;
    }else if(/^009\d$/.test(riskCode.code)){
      //限制购买
      // store.dispatch(setPayLoading(false));
      Toast.info('子基金限制购买' + riskCode.code, 2);
      return;
    }else if(/^0006$/.test(riskCode.code)){
      store.dispatch(setPayLoading(true));
      if(component != null){
        nav.push({
          pathname: component,
          state:params,
          query:params,
        });
      }else{
        params.callback();
      }
      return;
      // let riskModalData = {
      //   title: '风险提示',
      //   content: '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。',
      //   leftButtonTitle: '取消',
      //   rightButtonTitle: '继续购买',
      //   onOK: ()=>{
      //     store.dispatch(setRiskModalData(null));
      //     //购买
      //     params.fundRisk = true;
      //     params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
      //     if(component != null){
      //       nav.push({
      //         pathname:component,
      //         state:params,
      //         query:params,
      //       });
      //     }
      //   },
      //   onCancel: ()=>{
      //     store.dispatch(setRiskModalData(null));
      //   }
      // };
      // store.dispatch(setRiskModalData(riskModalData));
      // return;
    }else{
      // store.dispatch(setPayLoading(false));
      Toast.info('没有对应风险码：' + riskCode.code, 2);
      return;
    }
  }
}

export const getOpenHqt = async (route,nav,callback=null,obj=null)=>{  
  store.dispatch(setPayLoading(true));
  let flagDigital=await getStorage('loginState');
  let _currentUserInfo = await getStorage('currentUserInfo');
  if(flagDigital === '1'){ 
    //实名认证
    store.dispatch(clearSmrzOne())
    Toast.hide()
    nav.push({
        pathname:'/CertificationUpload',
        state:{
          route:route,
          phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
          callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? ()=>{ getOpenHqt(route,nav,callback) } : null
        }
    })
    return;
  }
  
  let didQuestionnairs = false;
  try{
    didQuestionnairs = await judgeQuestionnaires("S");
  }catch(err){
    Toast.hide();
    Toast.info(err.message, 2);
    return;
  }
  //判断：如果是私募产品并且公募问卷没有答完
  //如果是公募并且问卷没答完
  if(!didQuestionnairs){
    goPubQuestionnaires(nav, route, ()=>{getOpenHqt(route,nav,callback) });
    return;
  }

  let userInfo = store.getState().verifiedUserInfo;
  let findHqtExist = userInfo.content;
  store.dispatch(setPayLoading(false));
  if(findHqtExist.isOfficialsOrRelatives != null && findHqtExist.actualController && findHqtExist.actualControllerCertNo && findHqtExist.actualControllerCertType && findHqtExist.actualBeneficiary && findHqtExist.actualBeneficiaryCertNo && findHqtExist.actualBeneficiaryCertType ){
      if(findHqtExist.residentType != null){
        if(obj) {
          if(obj.bankAccountShowNo) {
            nav.push({
              pathname: "/HqtBindCard",
              state: {
                bankAccountShowNo: obj.bankAccountShowNo,
                paymentChannelId: obj.paymentChannel,
                bankAccountName: obj.bankName,
                certType: obj.certType,
                certNo:obj.certNo,
                router: obj.router,
                bankCode: obj.bankCode,
                openHqt: true,
                mobileNo: obj.mobileNo,
                callback: obj.callback,
                isShow: obj.isShow,
                fundCode: obj.fundCode
              }
            })
          }else {
            nav.push({
              pathname: "/HqtAddCard",
              state:{
                callback:callback,
                openHqt:true,
                router:route,
                fundCode: obj.fundCode
              }
            })
          }
        }else {
          nav.push({
            pathname: "/HqtAddCard",
            state:{
              callback:callback,
              openHqt:true,
              router:route,
            }
          })
        }
      }else{
        nav.push({
            pathname:"/ModifyTaxInfo",
            state:{
              route:route,
              callback:()=>{getOpenHqt(route,nav,callback)}
          }
        })
      }
  }else{
      nav.push({
        pathname:"/AddCertificationCard",
        state:{
          route:route,
          callback:()=>{getOpenHqt(route,nav,callback)}
        }
      })
  }
}

export const getPayAllSuper = async (route, params, nav, component = null)=>{
  store.dispatch(myPaymentText(''))
  store.dispatch(myFee('--'))
  store.dispatch(choseBankIndex(0))
  store.dispatch(choseCurrentIndex(0))
  store.dispatch(choseBankOrCurrent(false))
  store.dispatch(changeCurrentType(4))
  store.dispatch(changeCurrentIndex(0))
  Toast.loading('', 0);
  if (component=='RechargeHqt') {
    store.dispatch({
      type:"HQT_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }else if(component=='PaymentSuperFund'){
    store.dispatch({
      type:"SUPER_FUND_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }else if(component=='FixedInvestmentSuperFund'){
    store.dispatch({
      type:"SUPER_FUND_DT_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }else if(component=='PaymentAllSuperFund') {
    store.dispatch({
      type:"SUPER_FUND_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
    store.dispatch({
      type:"SUPER_FUND_DT_PAY_INFO",
      text:{code:'',message:'',content:{currencyFund:[],shareList:[],currentAccountList:[]},currentType:4,currentIndex:0}
    });
  }

  //已登录 已实名认证
  let flagDigital=await getStorage('loginState');
  let _currentUserInfo = await getStorage('currentUserInfo');
  console.log(flagDigital,'flagDigital11111')
  if(flagDigital == '1'){
    //实名认证
    store.dispatch(clearSmrzOne())
    Toast.hide()
    nav.push({
        pathname:'/CertificationUpload',
        state:{
          route:route,
          phoneNo:_currentUserInfo && _currentUserInfo.mobileNo ? _currentUserInfo.mobileNo : "",
          callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? ()=>{getPayAll(route, params, nav, component)} : null
        }
    })
    return;
  }else if(flagDigital=='3'){

    Toast.hide()
    //同步开户
    nav.push({
        pathname:'/BindingMobile',
        state:{route:route,callback:()=>{getPayAll(route, params, nav, component)}}
    })
    return;
  }else if(flagDigital=='0'){
    Toast.hide()
    nav.push({
        pathname: navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? '/LoginHxjj' : '/Login',
        state:{route:route,callback:navigator.userAgent.toLowerCase().indexOf("amcfmapp")>-1 ? ()=>{getPayAll(route, params, nav, component)} : null}
    })
    return;
  }

  if(params && params.productType == "Z") {
    Toast.loading('', 0);
    let hasConvertFlag = null;
    try {
      hasConvertFlag = await hasConvertingTrade({superFundCode: params.fundCode}, () => {
        Toast.hide();
      }, () => {
        Toast.hide();
      });
    }catch(err) {
      Toast.hide();
      return;
    }
    if(hasConvertFlag === true) {
      Toast.show('当前智投组合有转换在途交易，该操作暂停', Util.ToastTime);
      return;
    }
    Toast.loading('', 0);
  }

  let didQuestionnairs = false;//后台接口 判断是否做了问卷

  try{  
    let AccAgreementStatus = await querySuperFundAccAgreementStatus()
    console.log(AccAgreementStatus,"AccAgreementStatusAccAgreementStatus")
    let tempA = AccAgreementStatus && AccAgreementStatus.state;
    if(AccAgreementStatus === null || AccAgreementStatus === '' || tempA == "0"){
        nav.push({
          pathname:'/SuperFundSigning',
          state:{route:route,callback:()=>{getPayAll(route, params, nav, component)}}
        })
        // store.dispatch(superFundAccAgreementState(true))
        Toast.hide()
        return;
    }
    Toast.hide()
  }catch(err){
    Toast.info(err.message, 2);
    return
  }
  try{
    didQuestionnairs = await judgeQuestionnaires(params.productType);
  }catch(err){
    // store.dispatch(setPayLoading(false));
    Toast.info(err.message, 2);
    return;
  }
  //如果是公募并且问卷没答完
  if((params.productType == 'S' ||params.productType == 'G' || params.productType == 'J' || params.productType == 'Z') && !didQuestionnairs){
    goPubQuestionnaires(nav, route, ()=>{getPayAll(route, params, nav, component)});
    return;
  }

  if(true){
    //调后台接口公募接口
    let riskCode = '';
    Toast.loading('', 0);
    try{
      riskCode = await getRiskFlag(params.fundCode, params.productType);
      console.log('+++++++++',riskCode);
    }catch(err){
      // store.dispatch(setPayLoading(false));
      if(err.message != 'abort'){
        // alert(err.message);
        Toast.info(err.message, 2);
      }
      return;
    }
    Toast.hide()
    if(riskCode.code == ''){
      // store.dispatch(setPayLoading(false));
      return;
    }else if(riskCode.code == '0000'){
      // store.dispatch(setPayLoading(false));
      if(component != null){
        nav.push({
          pathname: component,
          state:params,
          query:params,
        });
      }else{
        params.callback();
      }
      return;
    }else if(/^90\d\d$/.test(riskCode.code) && riskCode.userRiskLevel == "1"){
      store.dispatch(setPayLoading(true));
      let riskModalData = {
        title: '风险提示',
        content: '您当前的风险承受能力为最低风险等级，根据证监会发布的《关于实施<证券期货投资者适当性管理办法>的规定》，最低风险等级的客户不能购买产品风险等级高于自身风险承受能力的产品。如果您对自己的风险等级有异议，建议重新测评。',
        leftButtonTitle: '取消',
        rightButtonTitle: '重新测评',
        contentBC: params.fundName + '风险高于您的风险承受能力',
        onOK: ()=>{
          //跳到重新测评
          // goReCheck();
          params.fundRisk = true;
          // params.fundPart = false;
          // UmengStatis.onEvent('Pay_GoReCheck');
          goPubQuestionnaires(nav, route, ()=>{getPayAll(route, params, nav, component)});
          store.dispatch(setRiskModalData(null));
          store.dispatch(setPayLoading(false));
        },
        onCancel: ()=>{
          // UmengStatis.onEvent('Pay_ReCheckCancel');
          store.dispatch(setRiskModalData(null));
        }
      };
      store.dispatch(setRiskModalData(riskModalData));
      // store.dispatch(traceSave({action: 'TRADE_REFUSE', message: '安全型用户购买非货币基金：' + params.fundName}));
      return;
    }else if(/^02\d\d$/.test(riskCode.code) || /^\d\d0[2,8]$/.test(riskCode.code)){
      //特高产品提示页，做题
      // store.dispatch(setPayLoading(false));
      goHighestRiskPoint(nav, route, ()=>{
        params.fundRisk = true;
        if(component != null){
          nav.push({
            pathname: component,
            state:params,
            query:params
          });
        }else{
          params.callback();
        }
      }, params.fundName);
      return;
    }else if(/^06\d\d$/.test(riskCode.code)){
      store.dispatch(setPayLoading(true));
      let riskModalData = {
        title: '风险提示',
        content: '本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。',
        leftButtonTitle: '取消',
        rightButtonTitle: '继续购买',
        onOK: ()=>{
          store.dispatch(setRiskModalData(null));
          //购买
          params.fundRisk = true;
          if(component != null){
            nav.push({
              pathname:component,
              state:params,
              query:params,
            });
          }
        },
        onCancel: ()=>{
          store.dispatch(setRiskModalData(null));
        }
      };
      if(riskCode.code == '0606'){
        // riskModalData.contentBC = '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。';
        riskModalData.contentBC = '';
        riskModalData.onOK = ()=>{
          store.dispatch(setRiskModalData(null));
          //购买
          params.fundRisk = true;
          params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
          if(component != null){
            nav.push({
              pathname:component,
              state:params,
              query:params,
            });
          }
        }
      }
      store.dispatch(setRiskModalData(riskModalData));
      return;
    }else if(/^90\d\d$/.test(riskCode.code)){
      //限制购买
      // store.dispatch(setPayLoading(false));
      Toast.info('限制购买', 2);
      return;
    }else if(/^009\d$/.test(riskCode.code)){
      //限制购买
      // store.dispatch(setPayLoading(false));
      Toast.info('子基金限制购买' + riskCode.code, 2);
      return;
    }else if(/^0006$/.test(riskCode.code)){
      store.dispatch(setPayLoading(true));
      if(component != null){
        nav.push({
          pathname: component,
          state:params,
          query:params,
        });
      }else{
        params.callback();
      }
      return;
      // let riskModalData = {
      //   title: '风险提示',
      //   content: '组合中的成分基金：' + riskCode.confirmFundCodeList.join('、') + '，高于您的风险承受能力。',
      //   leftButtonTitle: '取消',
      //   rightButtonTitle: '继续购买',
      //   onOK: ()=>{
      //     store.dispatch(setRiskModalData(null));
      //     //购买
      //     params.fundRisk = true;
      //     params.fundPart = riskCode.confirmFundCodeList.join('、') + '';
      //     if(component != null){
      //       nav.push({
      //         pathname:component,
      //         state:params,
      //         query:params,
      //       });
      //     }
      //   },
      //   onCancel: ()=>{
      //     store.dispatch(setRiskModalData(null));
      //   }
      // };
      // store.dispatch(setRiskModalData(riskModalData));
      // return;
    }else{
      // store.dispatch(setPayLoading(false));
      Toast.info('没有对应风险码：' + riskCode.code, 2);
      return;
    }
  }
}

const goHighestRiskPoint = (nav, route, callback, fundName)=>{
  nav.push({
    pathname:'/HighestRiskPoint',
    state: {
      route,
      callback,
      fundName
    }
  });
}

const getRiskFlag = async (fundCode, fundType)=>{
  let params = {
    token : await getTempInfo('shortToken')
  };
  if(fundType == 'Z')
    params.superFundCode = fundCode;
  else
    params.fundCode = fundCode;
  return new Promise((resolve, reject)=>{
    const successCallback = (suc)=>{
      if(suc && suc.code == '0000'){
        resolve(suc.content);
      }else{
        reject(new Error(suc.message));
      }
    };
    const errorCallback = (err)=>{
      if(err == 'abort')
        reject(new Error('abort'))
      else
        reject(new Error(Util.errorTxt));
    };
    let paramsForm = new FormData();
    for (let i in params) {
      paramsForm.append(i + '', params[i]);
    }
    let url=Util.url + '/api/trade/getRiskFlag'
     if (paramsForm) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) == -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    newFetch = _fetch(url,{
        method: "GET",
        mode:'cors',
      });
      newFetch.then((response) => response.json())
      .then((responseText) => {
        successCallback(responseText);
      })
      .catch(function(err){
        errorCallback(err);
        // store.dispatch(setPayLoading(false));
      });
    // Util.get(Util.url + '/api/trade/getRiskFlag', params, successCallback, errorCallback);
  })
}

const goPriQuestionnaires = async (nav, route, callback)=>{
  let privateFundParams = {
    token: await getTempInfo('shortToken'),
    raiseMethod: '7',
  };
  const getQuestionnaireNoSuccess = (questionnaireNo, raiseMethod)=>{
    // store.dispatch(setPayLoading(false));
    // nav.push({
    //   component: DeclareQualifiedInvestor,
    //   params: {
    //     questionnaireType: '私募',
    //     questionnaireTypeNumber: questionnaireNo,
    //     route: route,
    //     refreshPage: ()=>{callback()}
    //   }
    // })
  }
  const getQuestionnaireNoError = (msg)=>{
    // store.dispatch(setPayLoading(false));
    Toast.info(msg, 2);
  }
  // store.dispatch(getQuestionnaireNo(privateFundParams, (questionnaireNo, raiseMethod) => getQuestionnaireNoSuccess(questionnaireNo, raiseMethod), (msg) => getQuestionnaireNoError(msg)));
}

export const goPubQuestionnaires = async (nav, route, callback)=>{
  let publicFundParams = {
    token: await getTempInfo('shortToken'),
    raiseMethod: '9',
  };
  const getQuestionnaireNoSuccess = (questionnaireNo, raiseMethod)=>{
    store.dispatch(setPayLoading(false));
    nav.push({
      pathname: '/QuestionnaireList',
      state:{
        questionnaireType: '公募', 
        questionnaireTypeNumber: questionnaireNo,
        route: route,
        refreshPage:()=>{callback()}
      }
    });
  };
  const getQuestionnaireNoError = (msg)=>{
    // store.dispatch(setPayLoading(false));
    Toast.info(msg, 2);
  };
  store.dispatch(getQuestionnaireNo(publicFundParams, (questionnaireNo, raiseMethod)=> getQuestionnaireNoSuccess(questionnaireNo, raiseMethod), (msg)=> getQuestionnaireNoError(msg)));
}

const uploadForPrivate = async (nav, callback)=>{
  const successCallback = (suc)=>{
    callback();
    if(suc && suc.code == '0000'){
      if(suc.content == true){
        let riskModalData = {
          title : '提示',
          content: '您提交的私募合格投资者认证材料还在审核中，在此期间您还不能购买私募产品，请您耐心等待审核结果。',
          onOK : ()=>{
            store.dispatch(setRiskModalData(null));
          },
          modalType: 'message'
        }
        store.dispatch(setRiskModalData(riskModalData));
      }else{
        // nav.push({
        //   component: CertificationMainView
        // });
      }
    }else{
      Toast.info(suc.message, 2);
    }
  };
  const errorCallback = (err)=>{
    callback();
    Toast.info(Util.errorTxt, 2);
  };
  let params = {
    token: await getTempInfo('shortToken')
  }
  Util.post(Util.url + "/api/account/validateHasUploadFile", params, successCallback, errorCallback);
}

const isPrivate = ()=>{
  return new Promise(async (resolve, reject)=>{
    const successCallback = (suc)=>{
      if(suc && suc.code == '0000'){
        resolve(suc.content.isPrivate);
      }else{
        reject(new Error(suc.code));
      }
    };
    const errorCallback = (err)=>{
      reject(new Error(Util.errorTxt));
    };
    let params = {
      token: await getTempInfo('shortToken')
    }
    Util.post(Util.url + '/api/account/getRealUserInfo', params, successCallback, errorCallback)
  });
}

export const judgeQuestionnaires = async (productType)=>{
  let raiseMethod = '9';
  return new Promise(async (resolve, reject)=>{
    let params = {
      token: await getTempInfo('shortToken'),
      raiseMethod
    }
    const successCallback = (riskType, raiseMethod)=>{
      if(riskType)
        resolve(true);
      else
        resolve(false);
    }
    const errorCallback = (msg)=>{
      reject(new Error(msg));
    }
    store.dispatch(getRiskType(params, (riskType, raiseMethod)=>{successCallback(riskType, raiseMethod);}, (msg)=>{errorCallback(msg);}));
  })
}



export const querySuperFundAccAgreementStatus = async ()=>{
  return new Promise(async (resolve, reject)=>{
    let params = {
      token: await getTempInfo('shortToken'),
    }
    const successCallback = (res)=>{
        resolve(res);
    }
    const errorCallback = (msg)=>{
      reject(new Error(msg));
    }
    store.dispatch(querySuperFundAccAgreement(params, (res)=>{successCallback(res);}, (msg)=>{errorCallback(msg);}));
  })
}
//--------------------------------------//
// export function getPayDt(router,params,nav){
//   UmengStatis.onEvent('PublicOffering_FixedInvestment_Btn'); /*公募详情-定投按钮*/
//   // goLogin(nav,router,function(){
//   //   nav.push({
//   //     component: FixedInvestment,
//   //     params:params
//   //   });
//   // }.bind(this))
//   getPayAll(router, params, nav, FixedInvestment);
//   // isLoginAndRealName()
//   // .then((data) =>{
//   //   if(data==0){
//   //     nav.push({
//   //       component: Login,
//   //       params:{
//   //         route:router,
//   //         callback:getPayDt.bind(this,router,params,nav)
//   //       }
//   //     });
//   //   }else{
//   //     nav.push({
//   //     component: FixedInvestment,
//   //     params:params
//   //     });
//   //   }
//   // })
// }

// /*看是否登录，已经登录就走回调*/ 
// export function getToZx(router,nav,callback){
//   isLoginAndRealName()
//   .then((data) =>{
//     if(data==0){
//       nav.push({
//         component: Login,
//         params:{
//           route:router,
//           callback: callback
//         }
//       });
//     }else{
//       callback()
//     }
//   })
// }


//比较日期大小  
export function compareDate(checkStartDate, checkEndDate) {      
    var arys1= new Array();      
    var arys2= new Array();      
if(checkStartDate != null && checkEndDate != null) {      
    arys1=checkStartDate.split('-');      
      var sdate=new Date(arys1[0],parseInt(arys1[1]-1),arys1[2]);      
    arys2=checkEndDate.split('-');      
    var edate=new Date(arys2[0],parseInt(arys2[1]-1),arys2[2]);      
if(sdate > edate) {      
    return false;         
}  else {   
    return true;      
    }   
    }      
}     

/*把时间字符串转化为标准时间*/
export function getDateS(strDate) {
    // console.log(strDate,"strDatestrDate")
    // var date = eval('new Date(' + strDate.replace(/\d+(?=-[^-]+$)/,function (a) { return parseInt(a, 10) - 1; }).match(/\d+/g) + ')');
    var date = new Date(strDate)
    return date;
}


//判断日期，时间大小  
export function compareTime(startDate, endDate) {   
   if (startDate.length > 0 && endDate.length > 0) {  

      var allStartDate = getDateS(startDate);
      var allEndDate = getDateS(endDate);   

      if (allStartDate.getTime() >= allEndDate.getTime()) {   
            //console.log("startTime不能大于endTime，不能通过");   
          return false;   
      }else{   
          //console.log("startTime小于endTime，所以通过了");   
        return true;   
      }   
    }else{   
        //console.log("时间不能为空");   
        return false;   
    }   
}

export function compareTimeTwo(startDate, endDate) {   
   if (startDate.length > 0 && endDate.length > 0) {  

      var allStartDate = getDateS(startDate);
      var allEndDate = getDateS(endDate);   

      if (allStartDate.getTime() > allEndDate.getTime()) {   
            //console.log("startTime不能大于endTime，不能通过");   
          return false;   
      }else{   
          //console.log("startTime小于endTime，所以通过了");   
        return true;   
      }   
    }else{   
        //console.log("时间不能为空");   
        return false;   
    }   
}

// //2012-02-02  --- 2012-02-02 19:16;；两种格式；
// function compareCalendar(startDate, endDate) {   
//   if (startDate.indexOf(" ") != -1 && endDate.indexOf(" ") != -1 ) {   
//       //包含时间，日期  
//           compareTime(startDate, endDate);               
//   } else {   
//       //不包含时间，只包含日期  
//       compareDate(startDate, endDate);   
//   }   
// }

/*获取当前时间 年-月-日*/
export function getDateNow(){
    var resultDate,year,month,date,hms;
    var currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth()+1;
    date = currDate.getDate();
    hms = currDate.getHours() + ':' + currDate.getMinutes();
    month = (month < 10) ? ('0' + month) : month;
    date = (date < 10) ? ('0' + date) : date;
    resultDate = year + '-'+month+'-'+date;
  return resultDate;
}

/*获取当前时间 年-月-日-时-分*/
export function getTimeNow(){
    var resultDate,year,month,date,hms,hs,ms;
    var currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth()+1;
    date = currDate.getDate();
    hs = currDate.getHours();
    ms = currDate.getMinutes();
    hs = (hs < 10) ? ('0' + hs) : hs;
    ms = (ms < 10) ? ('0' + ms) : ms;
    month = (month < 10) ? ('0' + month) : month;
    date = (date < 10) ? ('0' + date) : date;
    hms = hs + ':' + ms;
    resultDate = year + '-'+month+'-'+date+' ' + hms;
  return resultDate;
}

/*获取三个月前的时间 年-月-日*/
export function get3MonthBefor(){
    var resultDate,year,month,date,hms;
    var currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth()+1;
    date = currDate.getDate();
    hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0'+currDate.getSeconds() : currDate.getSeconds());
    switch(month)
    {
      case 1:
      case 2:
      case 3:
        month += 9;
        year--;
        break;
      default:
        month -= 3;
        break;
    }
    month = (month < 10) ? ('0' + month) : month;
    resultDate = year + '-'+month+'-'+date;
  return resultDate;
}
/*获取一年前的时间 年-月-日*/
export function get1yearBefor(){
  var resultDate,year,month,date;
  var currDate = new Date();
  year = currDate.getFullYear()-1;
  month = currDate.getMonth()+1;
  date = currDate.getDate();
  month = (month < 10) ? ('0' + month) : month;
  resultDate = year+'-'+month+'-'+date;
  return resultDate;
}

/*获取一个月前时间 年-月-日*/
export function getOneMonthBefor(){
  var resultDate,year,month,date,hms;
    var currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth()+1;
    date = currDate.getDate();
    hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0'+currDate.getSeconds() : currDate.getSeconds());
    switch(month)
    {
      case 1:
        month += 11;
        year--;
        break;
      default:
        month -= 1;
        break;
    }
    month = (month < 10) ? ('0' + month) : month;
    resultDate = year + '-'+month+'-'+date;
  return resultDate;
}

/*获取三年前的时间 年-月-日*/
export function get3yearBefor(){
  var resultDate,year,month,date;
  var currDate = new Date();
  year = currDate.getFullYear()-3;
  month = currDate.getMonth()+1;
  date = currDate.getDate();
  month = (month < 10) ? ('0' + month) : month;
  date = (date < 10) ? ('0' + date) : date;
  resultDate = year+'-'+month+'-'+date;
  return resultDate;
}
/*获取半年前前的 年-月-日*/
export function getSixMonthBefor(){
  var resultDate,year,month,date,hms;
    var currDate = new Date();
    year = currDate.getFullYear();
    month = currDate.getMonth()+1;
    date = currDate.getDate();
    hms = currDate.getHours() + ':' + currDate.getMinutes() + ':' + (currDate.getSeconds() < 10 ? '0'+currDate.getSeconds() : currDate.getSeconds());
    switch(month)
    {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        month += 6;
        year--;
        break;
      default:
        month -= 6;
        break;
    }
    month = (month < 10) ? ('0' + month) : month;
    date = (date < 10) ? ('0' + date) : date;
    resultDate = year + '-'+month+'-'+date;
    // console.log(resultDate,"获取半年前前的")
  return resultDate;
}
/*获取五年前的时间 年-月-日*/
export function get5yearBefor(){
  var resultDate,year,month,date;
  var currDate = new Date();
  year = currDate.getFullYear()-5;
  month = currDate.getMonth()+1;
  date = currDate.getDate();
  month = (month < 10) ? ('0' + month) : month;
  date = (date < 10) ? ('0' + date) : date;
  resultDate = year+'-'+month+'-'+date;
  return resultDate;
}


/*当获取的字符串类型为null时*/

//智投转入、定投、转换特殊处理
export async function hasConvertingTrade(data, sucCallBack, errback){
  return new Promise((resolve, reject)=>{
    getTempInfo('shortToken').then( (d)=>{ 
      data.token = d;
      Util.get(Util.url+"/api/v1/superfund/trade/hasConvertingTrade",data,function(result){
        console.log(result);
        if (result.code=='0000') {
          sucCallBack();
          if(result.content === true || result.content === false) {
            resolve(result.content);
          }else {
            Toast.show( Util.errorTxt, Util.ToastTime);  
            reject("error");
          }
        }else{
          errback();
          Toast.show( result.message, Util.ToastTime )
          reject("error");
        }
      },function(error){
        errback();
        Toast.show( Util.errorTxt, Util.ToastTime );   
        reject("error");
      })
    }).catch( (err)=>{ 
      console.log(err)
      errback();
      reject("error");
    })
  })
}

/* 实名认证 */

/*获取 -年又-天  没区分年直接除365*/
export function dateDeath(starTime1,endTime1){
  //转换时间
  let endTime2=endTime1||getDateNow()
  let startime = new Date(starTime1);
  let endtime = new Date(endTime2);
  //得到两个时间的年月日
  var start={
    year:startime.getFullYear(),
    month:(startime.getMonth()-0) + 1,
    day:startime.getDate()
  }
  var end = {
    year:endtime.getFullYear(),
    month:(endtime.getMonth()-0)+1,
    day:endtime.getDate()
  }
  var diff={};
  //日期年份差值
  diff.year= end.year -  start.year;
  let star=new Date(((startime.getMonth()-0) + 1)+"/"+startime.getDate()+"/01")
  var endda =new Date(((endtime.getMonth()-0) + 1)+"/"+endtime.getDate()+"/01")
  //天数差值
  diff.day =computer(starTime1) % 365;
  let year=diff.year - 1
  let year1=((star.getTime()-0)>=(endda.getTime()-0)) ? year:diff.year
  let sj=""
  if(computer(starTime1) % 365 === 0){
    sj=year+'年'
  }else {
    if(year1 === 0) {
      sj=diff.day+'天'
    }else {
      if((star.getTime()-0)>=(endda.getTime()-0)){
        sj=year+'年又'+diff.day+'天'
      }else{
        sj=diff.year+'年又'+diff.day+'天'
      }
    }
  }
  return sj;
}
/*获取从今年起*/
export function Fromthisyear(){
  var resultDate,year;
  var currDate = new Date();
  year = currDate.getFullYear();
  resultDate = year + '-'+"01"+'-'+"01";
return resultDate;
}
/*获取距今多少天*/
export function computer(date){
  let now=new Date()//获取当前时间戳
  let future=new Date(date)//距离的时间
  let index=(now-future)/1000/(60*60*24)
  let day=parseInt(index)//天
  let str=day
 return str
}


// WEBPACK FOOTER //
// ./src/getPay.js